import { create } from 'zustand';

/**
 * Loopt de rondleiding nu, en bij welke stap?
 *
 * `requested` is de rondleiding die iemand zelf opnieuw start vanuit Account. De
 * eerste keer start hij vanzelf (zie `FirstRunTour`); dat volgt uit de sessie en
 * staat hier niet. `dismissedFor` onthoudt binnen deze keer openen voor wie hij
 * al is afgerond, ook als de API het nog niet heeft kunnen vastleggen. Per
 * persoon: logt een collega op dezelfde tablet in, dan krijgt die hem gewoon.
 */
interface TourState {
    requested: boolean;
    dismissedFor: string | null;
    index: number;
    /** Vanuit Account: opnieuw, vanaf de eerste stap. */
    request: () => void;
    goTo: (index: number) => void;
    /** Afgemaakt of overgeslagen, door deze persoon. */
    close: (userUuid: string | null) => void;
}

export const useTourStore = create<TourState>((set) => ({
    requested: false,
    dismissedFor: null,
    index: 0,

    request() {
        set({ requested: true, index: 0 });
    },

    goTo(index) {
        set({ index });
    },

    close(userUuid) {
        set({ requested: false, dismissedFor: userUuid, index: 0 });
    },
}));
